import * as React from 'react';

import { loadProductsFromCookieOldestFirst } from '@containers/ProductDetailContainer/ProductDetail/LastVisitedProducts/utils';
import { IProduct } from '@containers/ProductListing/model';

export const useLastVisitedItems = (productId: IProduct['id']) => {
  return React.useMemo<Array<IProduct['id']>>(() => {
    return loadProductsFromCookieOldestFirst()
      .filter((lastVisitedProductId) => lastVisitedProductId !== productId)
      .slice(-4)
      .reverse();
  }, [productId]);
};
